// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zojx","label":"styles_label__2F3LG"};